export default {
      id: "Icon--star-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--star",
      toString: function () {
        return this.url;
      }
    }